module.exports = __webpack_public_path__ + "img/RCT11.1878ed8f.svg";